import HttpResponse from "../../../../../utils/http/http.response";

export enum BillingsOrderForwardBillingsListResponseDataItemBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderForwardBillingsListResponseDataItemCargoOrder = {
  humanId: number;
};

export type BillingsOrderForwardBillingsListResponseDataItemConsumer = {
  name: string;
};

export type BillingsOrderForwardBillingsListResponseDataItemProducer = {
  name: string;
};

export type BillingsOrderForwardBillingsListResponseDataItem = {
  id: string;
  status: string | null;
  distance: number;
  amountForDistance: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  allContributionsAmount: number;
  baseDistanceRate: number;
  startTime: string;
  forwardingTime: string;
  cargoOrder: BillingsOrderForwardBillingsListResponseDataItemCargoOrder;
  consumer: BillingsOrderForwardBillingsListResponseDataItemConsumer;
  producer: BillingsOrderForwardBillingsListResponseDataItemProducer;
  billingModel: BillingsOrderForwardBillingsListResponseDataItemBillingModel;
  sumOfBonuses: number | null;
  sumOfPenalties: number | null;
  contractName: string;
  route: string[] | null;
};

export type BillingsOrderForwardBillingsListResponseData = {
  data: BillingsOrderForwardBillingsListResponseDataItem[];
  totalCount: number;
};

type BillingsOrderForwardBillingsListResponse =
  HttpResponse<BillingsOrderForwardBillingsListResponseData>;

export default BillingsOrderForwardBillingsListResponse;
